import * as Cookies from 'js-cookie';

var domainsData = [
  {
    brandName: 'businesstravel',
    brandCode: 'BUS',
    urlPattern: /businesstravel\.accor\.com/,
    code: 'ah',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'hotelf1',
    brandCode: 'HOF',
    urlPattern: /hotelf1\.accor\.com/,
    code: 'for',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'ibis',
    brandCode: 'IBI',
    urlPattern: /ibis\.accor\.com/,
    code: 'ibi',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'meetings',
    brandCode: 'MEE',
    urlPattern: /meetings\.accor\.com/,
    code: 'ah',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'mercure',
    brandCode: 'MER',
    urlPattern: /mercure\.accor\.com/,
    code: 'mer',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'mgallery',
    brandCode: 'MGA',
    urlPattern: /mgallery\.accor\.com/,
    code: 'mga',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'novotel',
    brandCode: 'NOV',
    urlPattern: /novotel\.accor\.com/,
    code: 'for',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'pullman',
    brandCode: 'PUL',
    urlPattern: /pullman\.accor\.com/,
    code: 'pul',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'sofitel',
    brandCode: 'SOF',
    urlPattern: /sofitel\.accor\.com/,
    code: 'sof',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'travelpros',
    brandCode: 'TRA',
    urlPattern: /travelpros\.accor\.com/,
    code: 'ah',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'all',
    brandCode: 'ACH',
    urlPattern: /all.accor\.com/,
    code: 'ah',
    gtmId: 'GTM-TKQN7D'
  }, {
    brandName: 'accorhotels.cn',
    brandCode: 'ACN',
    urlPattern: /\.accorhotels\.cn/,
    code: 'acn',
    gtmId: 'GTM-MQMZNH7'
  }, {
    brandName: 'thesebel',
    brandCode: 'SEB',
    urlPattern: /thesebel\.hotelandbook\.com/,
    code: 'seb',
    gtmId: 'GTM-MG78MFC'
  }, {
    brandName: 'resorts',
    brandCode: 'RST',
    urlPattern: /resorts\.accor\.com/,
    code: 'rst',
    gtmId: 'GTM-TKQN7D'
  }
];

var defaultDomainData = {
  brandName: 'all',
  brandCode: 'ACH',
  urlPattern: 'default',
  code: 'ah',
  gtmId: 'GTM-TKQN7D'
};

function getAppRoute() {
  var route = (function () {
    var metaXAccorRid = document.querySelectorAll('meta[name="X-Accor-rid"]')[0];
    if (metaXAccorRid) {
      return 'hotel/' + metaXAccorRid.content;
    }
    return 'homepage';
  })();
  return {
    android: {
      host: route,
      scheme: 'accorhotels',
      package: 'com.accor.appli.hybrid'
    },
    ios: 'accorhotels://' + route
  };
}

function getDomainData() {
  var host = location.hostname;
  for (var i = 0; i < domainsData.length; i++) {
    var domainData = domainsData[i];

    if (host.match(domainData.urlPattern)) {
      return domainData;
    }
  }

  return defaultDomainData;
}

function getCurrentDomain() {
  var domainData = getDomainData();

  // @see http://stackoverflow.com/questions/11401897/get-the-current-domain-name-with-javascript-not-the-path-etc
  var name = location.hostname.substring(location.hostname.lastIndexOf('.', location.hostname.lastIndexOf('.') - 1) + 1);

  return Object.assign({}, {
    isMobile: location.hostname.indexOf('m.' + name) > -1,
    rootHostname: name,
  }, domainData);
}

function getLang() {
  var value;
  var gbToEn = function (value) {
    return ((value === 'gb') ? 'en' : value);
  };

  value = document.location.href.match(/\/([a-z]{2}(?:-[a-z]{2})?)\//);
  if (value) {
    return gbToEn(value[1]);
  }

  value = document.documentElement.lang;
  if (value) {
    return gbToEn(value);
  }

  value = document.getElementsByTagName('html')[0].getAttribute('xml:lang');
  if (value) {
    return gbToEn(value);
  }


  return 'en';
}

function getCountry() {
  var geoZone;
  var contribZone;
  var geoZones = [
    'algeria', 'argentina', 'australia', 'austria', 'bahrain', 'belgium', 'benin', 'brazil', 'bulgaria', 'cambodia',
    'cameroon', 'canada', 'chad', 'chile', 'china', 'colombia', 'cuba', 'czech-republic', 'democratic-republic-lao',
    'democratic-republic-of-congo', 'denmark', 'dominican-republic', 'ecuador', 'egypt', 'equatorial-guinea', 'fiji',
    'finland', 'france', 'georgia', 'germany', 'ghana', 'greece', 'guatemala', 'hong-kong', 'hungary', 'india',
    'indonesia', 'ireland', 'israel', 'italy', 'ivory-coast', 'japan', 'jordan', 'kazakhstan', 'kuwait', 'latvia',
    'lebanon', 'lithuania', 'luxembourg', 'macao', 'macedonia', 'madagascar', 'malaysia', 'maurice', 'mexico',
    'morocco', 'myanmar', 'netherland', 'new-zealand', 'nigeria', 'norway', 'oman', 'other-regions-of-africa',
    'other-regions-of-asia', 'other-regions-of-europe', 'other-regions-of-middle-east',
    'other-regions-of-north-america', 'other-regions-of-south-america', 'panama', 'paraguay', 'peru', 'philippines',
    'poland', 'portugal', 'qatar', 'republic-of-korea', 'romania', 'russia', 'saudi-arabia', 'senegal', 'singapore',
    'slovakia', 'south-africa', 'spain', 'sweden', 'switzerland', 'taiwan', 'thailand', 'togo', 'tunisia', 'turkey',
    'ukraine', 'united-arab-emirates', 'united-kingdom', 'united-states-of-america', 'uruguay', 'viet-nam'
  ];

  var defaultContribZoneByGeoZone = {'other-regions-of-africa':'africa', 'other-regions-of-asia':'asia', 'australia':'australia', 'belgium':'belgium', 'brazil':'brasil', 'canada':'canada', 'china':'china',
    'other-regions-of-europe':'czech-republic-slovakia-hungary-romania', 'denmark':'denmark-norway-finland', 'germany':'deutschland', 'spain':'espana', 'france':'france', 'india':'india', 'indonesia':'indonesia',
    'ireland':'ireland', 'italy':'italia', 'japan':'japan', 'mexico':'mexico', 'other-regions-of-middle-east':'middle-east', 'netherland':'nederland', 'new-zealand':'new-zealand-fiji', 'austria':'oesterreich', 'poland':'polska',
    'portugal':'portugal', 'russia':'russia', 'malaysia':'singapore-malaysia', 'republic-of-korea':'south-korea', 'other-regions-of-south-america':'sudamerica', 'sweden':'sweden', 'switzerland':'switzerland',
    'hong-kong':'taiwan-hongkong-macao', 'thailand':'thailand', 'turkey':'turkey', 'united-kingdom':'united-kingdom', 'other-regions-of-north-america':'usa'};

  var defaultgeoZoneByLanguageCode ={
    'ar': 'other-regions-of-middle-east', 'de': 'germany', 'en': 'united-kingdom', 'es': 'spain', 'fr': 'france', 'id': 'indonesia', 'it': 'italy', 'ja': 'japan', 'ko': 'republic-of-korea',
    'nl': 'netherland', 'pl': 'poland', 'pt': 'portugal', 'pt-br': 'brazil', 'ru': 'russia', 'sv': 'sweden', 'th': 'thailand', 'tr': 'turkey', 'zh': 'china'
  };
  // url
  var country;
  var countryUrl = document.location.href.match(/\/([a-z]{2}(?:-[a-z]{2})?)\/([a-z-]*)/);
  if (countryUrl){
    geoZone = countryUrl[2];
    contribZone = defaultContribZoneByGeoZone[geoZone];
    if(contribZone){
      return contribZone;
    } else if( geoZones.indexOf(geoZone) != -1){
      return geoZone;
    }
  }
  //   Cookies
  country = Cookies.get('contribZone');
  if (country){
    return country;
  }
  //   Cookies 2
  country = Cookies.get('displayZone');
  if (country){
    return country;
  }
  // lang
  var lang = getLang();
  if (lang){
    geoZone = defaultgeoZoneByLanguageCode[lang];
    if(geoZone){
      contribZone = defaultContribZoneByGeoZone[geoZone];
      return (contribZone ? contribZone : geoZone);
    }
  }
}
function isInWebView() {
  var platform = Cookies.get('platform');
  return platform === 'APP-ANDROID' || platform === 'APP-IPHONE';
}

// @see https://www.abeautifulsite.net/detecting-mobile-devices-with-javascript
var isMobile = {
  Android: function () {
    return navigator.userAgent.match(/Android/i) && !isMobile.Windows();
  },
  BlackBerry: function () {
    return navigator.userAgent.match(/BlackBerry/i);
  },
  iOS: function () {
    return navigator.userAgent.match(/iPhone|iPad|iPod/i);
  },
  Opera: function () {
    return navigator.userAgent.match(/Opera Mini/i);
  },
  Windows: function () {
    return navigator.userAgent.match(/IEMobile|Windows Phone/i);
  },
  any: function () {
    return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
  },
  tablet: function () {
    var isTablet = false;
    var windowWidth = document.body.clientWidth;
    if (isMobile.any() && windowWidth > 768) {
      isTablet = true;
    }
    return isTablet;
  }
};

function isIE(){
  var ua = window.navigator.userAgent;

  var msie = ua.indexOf('MSIE ');
  if (msie > 0) {
    // IE 10 or older => return version number
    return parseInt(ua.substring(msie + 5, ua.indexOf('.', msie)), 10);
  }

  var trident = ua.indexOf('Trident/');
  if (trident > 0) {
    // IE 11 => return version number
    var rv = ua.indexOf('rv:');
    return parseInt(ua.substring(rv + 3, ua.indexOf('.', rv)), 10);
  }

  var edge = ua.indexOf('Edge/');
  if (edge > 0) {
    // Edge (IE 12+) => return version number
    return parseInt(ua.substring(edge + 5, ua.indexOf('.', edge)), 10);
  }

  // other browser
  return false;
}
export {
  getDomainData,
  getCurrentDomain,
  isInWebView,
  isIE,
  getLang,
  getCountry,
  getAppRoute,
  isMobile
}
